// نشستِ ادمین هنگام «ورود جایگزین» (به پنل کاربر یا سازمان) اینجا نگه داشته می‌شود
// تا هنگام «خروج» یا ازکارافتادنِ نشستِ جایگزین، به پنل ادمین برگردیم نه صفحهٔ ورود.
const KEY = 'impersonate_backup'

// ذخیرهٔ نشست ادمین — فقط یک‌بار (ورودِ تودرتو نباید پشتیبانِ اول را خراب کند).
export const saveAdminSession = ({ access, refresh, user }) => {
  if (localStorage.getItem(KEY)) return false
  try {
    localStorage.setItem(KEY, JSON.stringify({
      access: access || '',
      refresh: refresh || '',
      user: user || null,
    }))
    return true
  } catch (e) {
    return false
  }
}

export const hasAdminSession = () => !!localStorage.getItem(KEY)

/** خواندنِ محتوای توکن (بدون اعتبارسنجی) — فقط برای تشخیصِ نقش */
const decodeToken = (token) => {
  try {
    const part = String(token || '').split('.')[1]
    if (!part) return null
    const b64 = part.replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(b64).split('').map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
    )
    return JSON.parse(json)
  } catch (e) {
    return null
  }
}

/**
 * آیا نشستِ فعلی، «ورودِ جایگزینِ ادمین» است؟
 * یعنی ادمین از پنلِ ادمین با نقشِ پیمانکار/مشاور/ناظر/کاربرِ سازمان وارد شده است.
 * ملاک: توکنِ نشست با علامتِ `admin_impersonated` ساخته شده (فقط ادمین این را می‌گیرد).
 * پشتیبانِ نشست هم بررسی می‌شود تا بعد از رفرشِ صفحه هم درست کار کند.
 */
export const isAdminImpersonating = () => {
  const token = localStorage.getItem('access')
  const payload = decodeToken(token)
  if (payload && payload.admin_impersonated) return true

  const raw = localStorage.getItem(KEY)
  if (!raw) return false
  try {
    const b = JSON.parse(raw)
    if (b && b.user && b.user.role === 'Admin') return true
    const bp = decodeToken(b && b.access)
    return !!(bp && bp.admin_impersonated)
  } catch (e) {
    return false
  }
}

// کشِ ساده تا در هر رندر، توکن دوباره رمزگشایی نشود
let _cachedToken = null
let _cachedResult = false
export const isAdminImpersonatingCached = () => {
  const token = localStorage.getItem('access')
  if (token !== _cachedToken) {
    _cachedToken = token
    _cachedResult = isAdminImpersonating()
  }
  return _cachedResult
}

/**
 * آیا نشستِ فعلی «ورودِ جایگزین» است؟
 * یعنی ادمین یا کاربرِ سازمان، از پنلِ خودش واردِ پنلِ کاربرِ دیگر (پیمانکار) شده است.
 * (توکنِ این نشست‌ها با علامتِ `impersonated` ساخته می‌شود؛ ورودِ واقعیِ خودِ کاربر این علامت را ندارد.)
 *
 * در این حالت، اجبارِ «ثبتِ شمارهٔ تلفن» برای کاربرِ جایگزین‌شده اعمال نمی‌شود —
 * فقط وقتی خودِ کاربر وارد می‌شود، ثبتِ شماره تلفن لازم است.
 */
export const isImpersonatedSession = () => {
  const payload = decodeToken(localStorage.getItem('access'))
  return !!(payload && payload.impersonated)
}

// شروعِ «ورود جایگزین»: نشستِ فعلی (ادمین/سازمان) را نگه می‌دارد تا «خروج» به آن برگردد.
// اگر از قبل پشتیبانی باشد دست‌نخورده می‌ماند (ورودِ تودرتو نباید پشتیبانِ اول را خراب کند).
export const beginImpersonation = (currentUser) => {
  if (!currentUser || !currentUser.role) return false
  return saveAdminSession({
    access: localStorage.getItem('access'),
    refresh: localStorage.getItem('refresh'),
    user: currentUser,
  })
}

// پشتیبان را برمی‌گرداند و از حافظه پاک می‌کند (توکن‌ها را خودِ فراخوان تنظیم می‌کند).
export const takeAdminSession = () => {
  const raw = localStorage.getItem(KEY)
  if (!raw) return null
  localStorage.removeItem(KEY)
  try {
    const b = JSON.parse(raw)
    return (b && typeof b === 'object') ? b : null
  } catch (e) {
    return null
  }
}
